<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false" [hidden]="!kymw0E00Model.windowVisible">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">使用ページ確認</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <div class="element-column" [style.height.px]="750">
            <div class="column-list">
              <label class="list-input-title">画像名</label>
              <div class="list-input-content">
                <input type="text" id="lbl_ImageName" value="{{kymw0E00Model.imageName}}" readonly>
              </div>

              <label class="list-input-title">画像ファイル名</label>
              <div class="list-input-content">
                <input type="text" id="lbl_ImageFileName" value="{{kymw0E00Model.imageFileName}}" readonly>
              </div>
            </div>

            <div [hidden]="!kymw0E00Model.orderCodeVisible">
              <div class="column-list">
                <label class="list-input-title">変更前使用範囲</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_StartOrderCodeBefore" style="width: 7rem;" value="{{kymw0E00Model.startOrderCodeBefore}}" readonly>
                  <label>～</label>
                  <input type="text" id="lbl_EndOrderCodeBefore" style="width: 7rem;" value="{{kymw0E00Model.endOrderCodeBefore}}" readonly>
                </div>

                <label class="list-input-title">変更後使用範囲</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_StartOrderCodeAfter" style="width: 7rem;" value="{{kymw0E00Model.startOrderCodeAfter}}" readonly>
                  <label>～</label>
                  <input type="text" id="lbl_EndOrderCodeAfter" style="width: 7rem;" value="{{kymw0E00Model.endOrderCodeAfter}}" readonly>
                </div>
              </div>
            </div>

            <!-- データグリッド定義(使用範囲変更一覧) -->
            <wj-flex-grid #dtg_UseImage [itemsSource]="this.kymw0E00Model.usePageList"
              [headersVisibility]="'Column'" id="dtg_UseImage" [style.width.px]="575" [style.height.px]="676"
              forcedEnabledMode="true" [selectionMode]="'Row'" [isReadOnly]="true"
              (selectionChanged)="setColorPattern()" [tabindex]="0">
              <wj-flex-grid-column [minWidth]="5" [header]="'受注コード'" [width]="110" [binding]="'OrderCode'"
                [align]="'left'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'配達企画回(翌週)'" [width]="151" [binding]="'DlivCatalogId'"
                [align]="'left'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'媒体'" [width]="120" [binding]="'MediumName'"
                [align]="'left'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'会員生協'" [width]="104" [binding]="'CoopName'"
                [align]="'left'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'ページ'" [width]="70" [binding]="'PageNum'" [align]="'left'">
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>

        <!-- ここまで画面の内容を記述 -->
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_ChangeInfo" (click)="eventChangeInfoHandler(null)"
            [disabled]="!kymw0E00Model.btnEnabled" [tabindex]="0">変更確認</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventCloseWindowHandler(null)" id="btn_Close" #btn_Close></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>